export default __webpack_public_path__ + "static/media/tv.0f1ea21e.png";